var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrowser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00033 15.5V13.8333L4.83366 13H2.33366C1.87533 13 1.48296 12.8368 1.15658 12.5104C0.830187 12.184 0.666992 11.7917 0.666992 11.3333V2.16667C0.666992 1.70833 0.830187 1.31597 1.15658 0.989583C1.48296 0.663194 1.87533 0.5 2.33366 0.5H9.00033V2.16667H2.33366V11.3333H15.667V8.83333H17.3337V11.3333C17.3337 11.7917 17.1705 12.184 16.8441 12.5104C16.5177 12.8368 16.1253 13 15.667 13H13.167L14.0003 13.8333V15.5H4.00033ZM11.5003 10.5L7.33366 6.33333L8.50033 5.16667L10.667 7.3125V0.5H12.3337V7.3125L14.5003 5.16667L15.667 6.33333L11.5003 10.5Z",
    fill: "#666666"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowser);
export default __webpack_public_path__ + "static/media/browser.6ae97005.svg";
export { ForwardRef as ReactComponent };